'use client';

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import ReactDatePicker from 'react-datepicker';
import { StyledTextbox } from '@nib-components/textbox';
import customStyles from './style';
import { breakpoint } from '@nib/layout';
import { CalendarSystemIcon } from '@nib/icons';
import MaskedInput from 'react-text-mask';
const StylesheetWrapper = styled.div.attrs({
  'data-mesh-component': 'DATE-PICKER'
})`
  ${customStyles};
  touch-action: manipulation;

  .react-datepicker__aria-live {
    position: absolute;
    clip-path: circle(0);
    border: 0;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    width: 1px;
    white-space: nowrap;
  }
`;
StylesheetWrapper.displayName = 'StylesheetWrapper';
const Relative = styled.div`
  position: relative;
`;
export const ShowAtSm = styled.div`
  ${breakpoint('xs')`
    display: none;
  `}
  ${breakpoint('sm')`
    display: block;
  `}
`;
export const HideAtSm = styled.div`
  ${breakpoint('xs')`
    display: block;
  `}
  ${breakpoint('sm')`
    display: none;
  `}
`;
export const CalendarIcon = styled(CalendarSystemIcon)`
  position: absolute;
  inset-block-start: 50%;
  transform: translateY(-50%);
  inset-inline-end: 1rem;
  pointer-events: none;
  display: none;
  ${breakpoint('mini')`
    display: block;
  `}

  ${_ref => {
  let {
    disabled
  } = _ref;
  return disabled && `
      opacity: 0.5;
    `;
}}
`;
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const MaskedDateInput = /*#__PURE__*/React.forwardRef((props, ref) => {
  const mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  return /*#__PURE__*/_jsx(MaskedInput, {
    guide: false,
    mask: mask,
    ref: ref,
    ...props,
    render: (ref, props) => /*#__PURE__*/_jsx(StyledTextbox, {
      ref: ref,
      ...props,
      inputMode: "numeric"
    })
  });
});
//The hide and show code below is here to stop the keyboard input for mobile
//until we add auto date masking and then we can use the numeric keyboard without issues
export const CalendarTextbox = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/_jsxs(Relative, {
  children: [/*#__PURE__*/_jsx(HideAtSm, {
    children: /*#__PURE__*/_jsx(StyledTextbox, {
      ref: ref,
      ...props,
      readOnly: "readonly"
    })
  }), /*#__PURE__*/_jsx(ShowAtSm, {
    children: props.hasMask ? /*#__PURE__*/_jsx(MaskedDateInput, {
      ref: ref,
      ...props
    }) : /*#__PURE__*/_jsx(StyledTextbox, {
      ref: ref,
      ...props
    })
  }), !props.validated && /*#__PURE__*/_jsx(CalendarIcon, {
    disabled: props.disabled,
    size: props.isCompact ? 20 : 'sm'
  })]
}));
const CustomInput = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/_jsx(CalendarTextbox, {
  ref: ref,
  ...props
}));
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const DatePicker = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    dateFormat = 'dd/MM/yyyy',
    hasMask = false,
    ...props
  } = _ref2;
  return /*#__PURE__*/_jsx(StylesheetWrapper, {
    children: /*#__PURE__*/_jsx(ReactDatePicker, {
      ref: ref,
      customInput: /*#__PURE__*/_jsx(CustomInput, {
        dateFormat: dateFormat,
        hasMask: hasMask,
        ...props
      }),
      dateFormat: dateFormat,
      popperPlacement: "bottom-start",
      autoComplete: "off",
      ...props
    })
  });
});
export default DatePicker;